<template>
  <div>
    <v-container class="py-8" fluid>
      <v-card elevation="0">
        <v-card-title
          class="text-h5 mb-2 text-start font-weight-bold text-primary"
        >
          {{ `Pricing Details` }}
        </v-card-title>
        <v-card-text class="text-start">
          <div class="mb-4 font-weight-semibold text-subtitle1 text-secondary">
            Welcome to <strong>Quizzr</strong>.
            We offer flexible pricing plans to suit different users — from
            casual quizzers to large organizations.
          </div>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-card elevation="2" class="pa-4 mx-2 text-center text-blue">
                <h3 class="text-subtitle1">Starter Plan</h3>
                <p class="my-2 text-h5 font-weight-bold">₹100</p>
                <ul class="text-left mx-4">
                  <li>Perfect for getting started with quizzes</li>
                  <li>100 Credits</li>
                </ul>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-card elevation="2" class="pa-4 mx-2 text-center text-green">
                <h3 class="text-subtitle1">Basic Plan</h3>
                <p class="my-2 text-h5 font-weight-bold">₹500</p>
                <ul class="text-left mx-4">
                  <li>Great value with bonus credits</li>
                  <li>550 Credits</li>
                </ul>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-card elevation="2" class="pa-4 mx-2 text-center text-orange">
                <h3 class="text-subtitle1">Premium Plan</h3>
                <p class="my-2 text-h5 font-weight-bold">₹1000</p>
                <ul class="text-left mx-4">
                  <li>Best value for regular quiz takers</li>
                  <li>1200 Credits</li>
                </ul>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-card elevation="2" class="pa-4 mx-2 text-center text-purple">
                <h3 class="text-subtitle1">Ultimate Plan</h3>
                <p class="my-2 text-h5 font-weight-bold">₹5000</p>
                <ul class="text-left mx-4">
                  <li>Maximum credits for power users</li>
                  <li>6500 Credits</li>
                </ul>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script></script>
